exports.languagePackReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_LANGUAGE_PACK':
            return {
                ...state,
                ...action.languagePack
            }

        default:
            return {
                ...state
            }
    }
}

exports.entertaimentReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_ENTERTAIMENT_LIST':
            return {
                ...state,
                ...action
            }
        default:
            return {
                ...state
            }
    }
}


exports.projectsReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_PROJECT_LIST':
            return {
                ...state,
                ...action.data
            }
        default:
            return {
                ...state
            }
    }
}


// WEBPACK FOOTER //
// ./src/reduces/default.js